__turbopack_context__.v({
  "button": "tooltip-module-scss-module___bPAea__button",
  "content": "tooltip-module-scss-module___bPAea__content",
  "icon": "tooltip-module-scss-module___bPAea__icon",
  "tooltip": "tooltip-module-scss-module___bPAea__tooltip",
});
